/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Native_NameInputs */

const en_reference_field_native_name = /** @type {(inputs: Reference_Field_Native_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Native name`)
};

/**
* | output |
* | --- |
* | "Native name" |
*
* @param {Reference_Field_Native_NameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_native_name = /** @type {((inputs?: Reference_Field_Native_NameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Native_NameInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_native_name(inputs)
});